import React, { useState } from "react";
import BetInsightsTable from "./BetInsightsTable";
import BetInsightsForm from "./BetInsightsForm";


const BetInsights = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-900">Bet - Insights</h2>
      </div>

      {showForm && (
        <BetInsightsForm
        />
      )}
      <BetInsightsTable
      />
    </div>
  );
};
export default BetInsights;
